import Price from 'snippets/price/price'

function PlpCardPrice({ price, originalPrice, isCartRelated = false }) {
  const customClassPrice = () => {
    let classSize = 'text-sm font-medium whitespace-nowrap'
    if (originalPrice && originalPrice !== 0) {
      const newClassSize = originalPrice > price ? ' text-grey-300' : ' text-grey-700'
      classSize += newClassSize
    }
    return classSize
  }

  const priceClassName = isCartRelated
    ? 'plp-card-price flex flex-col-reverse items-start gap-0 text-grey-700'
    : 'plp-card-price flex flex-row-reverse justify-end gap-x-2 text-grey-700 flex-wrap'

  return (
    <Price
      price={price}
      originalPrice={originalPrice}
      className={priceClassName}
      classSize={customClassPrice()}
      classColor="!text-accent-4"
      salePretext="Now"
    />
  )
}

export default PlpCardPrice
